import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import * as styles from "./mediaSection.module.css";
import { Typography } from "@mui/material";

export default ({ node }) => {
  const { mediaHeadline, mediaType, mediaFile } = node;

  let previewImg = "";
  if (mediaFile && mediaFile.asset) {
    previewImg = mediaFile.asset.url;
  }
  return (
    <Box>
      <Grid container class={styles.mediaSectionContainer}>
        <Grid item xs={12} className={styles.mediaSectionHeadTextGrid}>
          <Typography
            dangerouslySetInnerHTML={{ __html: mediaHeadline }}
            className={styles.mediaSectionHeadText}
          />
        </Grid>
        <Grid item xs={12}>
          {mediaType == "video" ? (
            <video
              controls={false}
              autoPlay={true}
              loop={true}
              muted={true}
              className={styles.mediaSectionMedia}
              src={previewImg}
            ></video>
          ) : (
            <img src={previewImg} className={styles.mediaSectionMedia} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
